<template>
  <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <div class="b2b-section">
            <div class="row justify-content-center">
              <div class="col-11 col-sm-10 col-md-7 col-lg-7 col-xl-6 col-xxl-5">
                <div class="b2b-section__box">
                  <h4 class="b2b-section__title">{{ $t('pages.homepage.b2b_section_title') }}</h4>
                  <div class="b2b-section__message">
                    {{ $t('pages.homepage.b2b_section_txt') }}
                  </div>
                  <div>
                    <a :href="getB2BUrl(metricB2B.BOX_CTA)" class="btn btn-primary"
                       target="_blank">{{ $t('pages.homepage.b2b_section_btn') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {getB2BUrl, metricB2B} from "@/utils";
  export default {
    computed: {
      metricB2B() {
        return metricB2B
      }
    },
    methods: {getB2BUrl},
}
</script>

<style scoped>

</style>